export default __webpack_public_path__ + "static/hopper-eb0fb3fce04c197a2eda7ebefd51281b.png";